import { models } from 'powerbi-client';
import { getPowerBiTheme } from '../../contentLibrary/IngestLibraryItemModal/getPowerBiTheme';
import userTokenService from '../../../common/services/security/userTokenService';

export const footerHeight = 51 + 24 + 24;

export const calcContentHeight = (h) =>
  // 80% of the window height
  h * 0.8 -
  // header
  (88 + 2 + 10) -
  // footer
  footerHeight;

export const computeContainerDimensions = (height, width, isSinglePage) => {
  const BOTTOM_TOOLBAR_HEIGHT = 20;
  const computedHeight = isSinglePage ? height - BOTTOM_TOOLBAR_HEIGHT : height;
  const computedWidth = width;

  return [computedHeight, computedWidth];
};

export const buildPowerBiReportConfig = ({
  embedToken,
  embedUrl,
  pageName,
  reportId,
  isDarkMode,
  projectId,
  skipPowerBiTheme = false,
}) => {
  const config = {
    type: 'report',
    tokenType: models.TokenType.Embed,
    accessToken: embedToken,
    embedUrl,
    id: reportId,
    permissions: models.Permissions.All,
    settings: {
      commands: [
        {
          exportData: {
            displayOption: userTokenService.isPwcReadOnlyRole(projectId)
              ? models.CommandDisplayOption.Hidden
              : models.CommandDisplayOption.Enabled,
          },
        },
      ],
      panes: {
        pageNavigation: {
          visible: !pageName,
        },
        filters: {
          expanded: false,
          visible: !pageName,
        },
      },
      layoutType: models.LayoutType.Custom,
      customLayout: {
        displayOption: models.DisplayOption.ActualSize,
        pageSize: {
          type: models.PageSizeType.Custom,
          width: '100%',
          height: '100%',
        },
      },
    },
    pageName,
    theme: getPowerBiTheme(isDarkMode),
  };

  if (skipPowerBiTheme) {
    delete config.theme;
  }

  return config;
};

export const openFullScreen = (element) => {
  if (element.requestFullscreen) {
    element.requestFullscreen();
    return;
  }
  if (element.webkitRequestFullscreen) {
    /* Safari */
    element.webkitRequestFullscreen();
    return;
  }
  if (element.msRequestFullscreen) {
    /* IE11 */
    element.msRequestFullscreen();
  }
};
